import { render, staticRenderFns } from "./ReturnGoodsItem.vue?vue&type=template&id=4e103464&scoped=true"
import script from "./ReturnGoodsItem.vue?vue&type=script&lang=js"
export * from "./ReturnGoodsItem.vue?vue&type=script&lang=js"
import style0 from "./ReturnGoodsItem.vue?vue&type=style&index=0&id=4e103464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e103464",
  null
  
)

export default component.exports